<div class="npdc-title">
  <h1>Application tokens</h1>
  <div class="npdc-title__actions">
    <a mat-flat-button routerLink="new">New application token</a>
  </div>
</div>

<p>
  An application token can be used instead of a bearer token to get authorized access on
  preconfigured endpoints.
</p>

@if (token(); as token) {
  <pre>{{ token }}</pre>
}

<app-list [resource]="applications" [disableClear]="true">
  @if (!applications.error()) {
    <mat-nav-list>
      @for (app of applications.value()?.items; track app.id) {
        <a mat-list-item routerLink="{{ app.id }}/edit">
          <mat-icon matListItemIcon>robot</mat-icon>
          <span matListItemTitle>{{ app.name }}</span>
          <span matListItemLine>
            @if (app.createdBy | resolveUser | async; as user) {
              <span>{{ user.email }}</span>
            } @else {
              <span>{{ app.createdBy }}</span>
            }
          </span>
          <span matListItemLine>{{ app.validUntil | date }}</span>
        </a>
      }
    </mat-nav-list>
  }
</app-list>
